import React from "react";

export function Logo({ className = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        <rect x="2" y="2" width="34" height="34" rx="10" fill="url(#sp-grad)" />
        <path d="M12 12.5C12 11.7 12.7 11 13.5 11H16c.7 0 1.3.5 1.4 1.2l.5 2.5c.1.6-.1 1.2-.6 1.5l-1.4 1c.9 1.9 2.5 3.5 4.4 4.4l1-1.4c.3-.5.9-.7 1.5-.6l2.5.5c.7.1 1.2.7 1.2 1.4V25c0 .8-.7 1.5-1.5 1.5C17.5 26.5 11.5 20.5 11.5 13c0-.2 0-.3.5-.5z" fill="white" />
        <circle cx="27.5" cy="11.5" r="5" fill="#10B981" stroke="white" strokeWidth="1.5" />
        <path d="M25.3 11.5l1.4 1.4 2.6-2.8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
          <linearGradient id="sp-grad" x1="2" y1="2" x2="36" y2="36" gradientUnits="userSpaceOnUse">
            <stop stopColor="#2563EB" />
            <stop offset="1" stopColor="#1D4ED8" />
          </linearGradient>
        </defs>
      </svg>
      {showText && (
        <span className="font-display font-extrabold text-xl tracking-tight text-slate-900 dark:text-white">
          Sorgu<span className="text-blue-600 dark:text-blue-400">Panel</span>
        </span>
      )}
    </div>
  );
}
